export const isValidMonthFormat = (dateStr: string): boolean => {
  const regex = /^\d{4}-(0[1-9]|1[0-2])$/;
  return regex.test(dateStr);
};

export const isValidMonthDate = (dateStr: string): boolean => {
  if (!isValidMonthFormat(dateStr)) {
    return false;
  }

  const [year, month] = dateStr.split('-').map(Number);
  const currentYear = new Date().getFullYear();

  // Allow dates from 2020 to current year + 1
  if (year < 2020 || year > currentYear + 1) {
    return false;
  }

  // Month should be between 1-12 (already validated by regex)
  return month >= 1 && month <= 12;
};

export const sanitizeMonthDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) {
    return getCurrentMonth();
  }

  if (isValidMonthDate(dateStr)) {
    return dateStr;
  }

  // Return current month as fallback
  return getCurrentMonth();
};

export const getCurrentMonth = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export const isValidRange = (value: number, min: number, max: number): boolean => {
  return !isNaN(value) && value >= min && value <= max;
};

export const isValidOrderCount = (count: number | null): boolean => {
  if (count === null) return true;
  return isValidRange(count, 0, 999999);
};

export const sanitizeStringArray = (arr: any[]): string[] => {
  if (!Array.isArray(arr)) {
    return [];
  }

  return arr
    .filter(item => typeof item === 'string' && item.trim().length > 0)
    .map(item => item.trim());
};

export const isValidCountryId = (id: number | null): boolean => {
  if (id === null) return true;
  return isValidRange(id, 1, 999);
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), wait);
  };
};
